import { usePositionsContext } from '@/creditflowresearch/application/PortfolioMonitor/PositionsContext';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import Checkbox from '@creditflowresearch/uilib/Checkbox';
import IconTrash from '@creditflowresearch/uilib/Icon/IconTrash';
import IconButton from '@creditflowresearch/uilib/IconButton';
import { AgingCell, BondNameCell } from '@/creditflowresearch/ui/common/components/TableCells';
import { LastTableCell } from '@framework/ui/Molecules/Tables/TableWrapper';
import { usePortfolioMonitorContext } from '@/creditflowresearch/application/PortfolioMonitor/PortfolioMonitorContext';

import styles from './positionsTable.module.scss';
import cellStyles from '@/creditflowresearch/ui/common/components/TableCells/styles.module.scss';

export const PositionSizeCell = ({ row, cellName, format }) => {
  const cellValue = row[cellName] || '-';
  return format ? format(cellValue) : cellValue;
};

export const SelectCell = (cellProps) => {
  const { row: { cusip } } = cellProps;
  const { selection: { addRows, removeRows, collection: selectedRows } } = usePositionsContext();
  const isChecked = selectedRows.includes(cusip);

  const onChange = ({ target: { name } }) => (isChecked ? removeRows([name]) : addRows([name]));

  return (
    <Checkbox
      name={ cusip }
      dataTest="position"
      checked={ isChecked }
      onChange={ onChange }
    />
  );
};

export const SelectAllCell = () => {
  const { positionList, selection: { addRows, removeRows, collection: selectedRows } } = usePositionsContext();
  const isChecked = positionList.collection.every(
      ({ cusip }) => selectedRows.find((item) => item === cusip),
  ) && (positionList.collection.length > 0);
  const positionListIds = positionList.collection.map(({ cusip }) => cusip);

  const onChange = () => (isChecked ? removeRows(positionListIds) : addRows(positionListIds));

  return (
    <Checkbox
      name="positionAll"
      dataTest="positionAll"
      checked={ isChecked }
      onChange={ onChange }
    />
  );
};

export const PositionsLastCell = (cellProps) => {
  const { selection, confirmDeletePositionsModal: { showCanceledModal } } = usePositionsContext();

  const onDeleteClick = () => {
    selection.addRows([cellProps.row.cusip]);
    showCanceledModal();
  };

  return (
    <LastTableCell childrenToShowOnHover={ (
      <IconButton
        icon={ <IconTrash className={ styles.deleteIcon } /> }
        className={ styles.deleteButton }
        onClick={ onDeleteClick }
        ariaLabel={ `Delete position ${ cellProps.row.cusip }` }
        dataTest="deletePosition"
      />
      ) }
    >
      <AgingCell { ...cellProps } />
    </LastTableCell>
  );
};

export const PositionBondNameCell = (cellProps) => {
  if (cellProps.row.deal) {
    return <BondNameCell { ...cellProps } />;
  }

  if (cellProps.cellData) {
    return (
      <Tooltip content={ cellProps.cellData }>
        <span className={ cellStyles.nameCell }>{ cellProps.cellData }</span>
      </Tooltip>
    );
  }
  return '-';
};

export const CurrencyCell = ({ positionColumnName, ...cellProps }) => {
  const { currencies: { collection } } = usePortfolioMonitorContext();
  const { row } = cellProps;
  const currency = collection.find((currency) => currency.id === row?.currencyId);

  if (!currency?.displayName || !row[positionColumnName]) {
    return '-';
  }

  return currency.displayName;
};
